import { QuickViewState as QuickView, ThemeProvider } from '@boost-sd/app';
import { createRoot } from 'react-dom/client';

import type { Block } from '../types';

export type QuickViewBlock = Block<unknown>;

export const createQuickViewBlock = (): QuickViewBlock => {
  return {
    config: {},
    render() {
      const quickViewContainerId = 'boost-sd__quick-view-container';
      const quickViewContainer = document.createElement('div');
      quickViewContainer.setAttribute('id', quickViewContainerId);
      document.body.appendChild(quickViewContainer);

      const root = createRoot(quickViewContainer);

      root.render(
        <ThemeProvider>
          <QuickView />
        </ThemeProvider>
      );
    },
  };
};
